<div class="d-flex navigation-header">
  <h1 (click)="goBack()" id="panel">{{"admin.title" | translate }}</h1>
  <h1>&nbsp; > {{"admin.banner.title" | translate}}</h1>
</div>

<div class="container-card">
  <hr/>
  <h1>{{"admin.banner.changeText" | translate}}</h1>
  <div>
    <textarea [(ngModel)]="databaseText" rows="4" cols="30" class="form-control" [placeholder]=" "></textarea>
  </div>


  <div>
    <button [disabled]="!databaseText" mat-flat-button color="primary" class="action-button" (click)="uploadText()">
      {{'admin.banner.confirmText' | translate}}
    </button>
  </div>

  <hr/>

  <h1>{{"admin.banner.uploadFile" | translate}}</h1>

  <div>
    <div>
      <button [disabled]="false" mat-flat-button color="primary" class="action-button">
        <input id="file" type="file" (change)="onFileChanged($event)" style="display: none">
        <label for="file" style="cursor: pointer">
          {{'admin.banner.chooseFile' | translate}}
        </label>
      </button>
      <label style="margin-left: 10px">{{selectedFile?.name}}</label>
    </div>
    <div>
      <button [disabled]="!selectedFile" mat-flat-button color="primary" class="action-button" (click)="uploadImage()">
        {{'admin.banner.uploadFile' | translate}}
      </button>
    </div>
  </div>

  <mat-card *ngIf="loading" class="spinner-wrapper">
    <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
  </mat-card>

  <hr/>

  <h1>{{"admin.banner.changeUrl" | translate}}</h1>
  <div>
    <textarea [(ngModel)]="databaseUrl" rows="1" cols="30" class="form-control" [placeholder]=" "></textarea>
  </div>


  <div>
    <button mat-flat-button color="primary" class="action-button" (click)="uploadUrl()">
      {{'admin.banner.confirmUrl' | translate}}
    </button>
  </div>

  <hr/>

  <div>
    <button mat-flat-button color="primary" class="action-button" (click)="downloadImage()">
      {{'admin.banner.loadImage' | translate}}
    </button>
  </div>
  <ng-container *ngIf="databaseImage">
    <div *ngIf="databaseText" style="display: flex; margin-left: 60px">
      <p class="description" [innerHTML]="databaseText"></p>
    </div>
    <a *ngIf="databaseUrl; else noUrl" [href]="databaseUrl" target="_blank">
      <img [src]="databaseImage" style="width: 100%; cursor: pointer;" />
    </a>
    <ng-template #noUrl>
      <img [src]="databaseImage" style="width: 100%; cursor: default;" />
    </ng-template>
  </ng-container>
</div>
